/**
 * Admin Unlayer authoring routes under /admin-dashboard/templates.
 * Create opens as a modal on the templates tab; only edit hides admin chrome.
 */

const ADMIN_TEMPLATE_EDIT_PATH = /^\/admin-dashboard\/templates\/[a-fA-F0-9]{24}\/edit\/?$/;

export function isAdminTemplateEditorRoute(pathname: string): boolean {
  return ADMIN_TEMPLATE_EDIT_PATH.test(pathname);
}

/** True when admin dashboard chrome should hide for Unlayer authoring. */
export function isAdminTemplateAuthoringPath(pathname: string): boolean {
  return isAdminTemplateEditorRoute(pathname);
}

export function buildAdminTemplateEditorPath(templateId: string): string {
  return `/admin-dashboard/templates/${encodeURIComponent(templateId)}/edit`;
}

export function buildAdminTemplateEditorUrl(templateId: string, type?: string): string {
  const params = new URLSearchParams();
  params.set('returnTo', '/admin-dashboard?tab=templates');
  if (type === 'email') {
    params.set('emailTemplateContext', 'true');
  }
  if (type === 'contact-form') {
    params.set('contactFormContext', 'true');
  }
  return `${buildAdminTemplateEditorPath(templateId)}?${params.toString()}`;
}
